import ApiService from "services/ApiService";
import ApiRequestService from "services/ApiRequestService";

const badRequestCode = 400;

export const PcnService = {
    searchPcns(searchRequest) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/admin/pcn/search`, searchRequest)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    getOptions() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/pcn/Options`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    getOnHoldPcn(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/pcn/HoldingArea/${id}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    updateOnHoldPcn(id, request) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/pcn/HoldingArea/${id}`, request)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    getPcn(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/pcn/admin/pcn/${id}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    deletePcn(id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/pcn/admin/pcn/${id}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    uploadAttachment(id, file) {

        const config = {
            headers: {
                "content-Type": "multipart/form-data",
            },
        };

        const formData = new FormData();
        formData.append("file", file);

        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/admin/pcn/${id}/Attachments`, formData, config)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        if (error.response.status === badRequestCode) {
                            reject(error.response.data);
                        } else {
                            reject("An unknown error occurred");
                        }
                    }
                );
        });
    },
    addPcnNote(id, noteText) {
        return ApiRequestService.post('pcn', `Admin/PCN/${encodeURIComponent(id)}/Notes`, { noteText });
    },
    updatePcnNote(id, noteId, noteText) {
        return ApiRequestService.put('pcn', `Admin/PCN/${encodeURIComponent(id)}/Notes/${encodeURIComponent(noteId)}`, { noteText });
    },
    deletePcnNote(id, noteId) {
        return ApiRequestService.delete('pcn', `Admin/PCN/${encodeURIComponent(id)}/Notes/${encodeURIComponent(noteId)}`);
    },
    addAsset(request) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/admin/asset`, request)
                .then(
                    (response) => {
                        resolve(parseInt(response.data));
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    searchContraventionCodes(request) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/ContraventionCodes/Search`, request)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    getContraventionCode(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/pcn/ContraventionCodes/${id}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    createContraventionCode(body) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/ContraventionCodes`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    updateContraventionCode(id, body) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/pcn/ContraventionCodes/${id}`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    searchStatusComments(request) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/StatusComments/Search`, request)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    getStatusComment(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/pcn/StatusComments/${id}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    createStatusComment(body) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/StatusComments`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    updateStatusComment(id, body) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/pcn/StatusComments/${id}`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    searchStatuses(request) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/Statuses/Search`, request)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    getStatus(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/pcn/Statuses/${id}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    createStatus(body) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/Statuses`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    updateStatus(id, body) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/pcn/Statuses/${id}`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    searchContraventionReasons(request) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/ContraventionReasons/Search`, request)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    getContraventionReason(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/pcn/ContraventionReasons/${id}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    createContraventionReason(body) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/ContraventionReasons`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    updateContraventionReason(id, body) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/pcn/ContraventionReasons/${id}`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    searchIssuingAuthorities(searchRequest) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/IssuingAuthorities/Search`, searchRequest)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    getIssuingAuthority(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/pcn/IssuingAuthorities/${id}`)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    createIssuingAuthority(body) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/pcn/IssuingAuthorities`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    updateIssuingAuthority(id, body) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/pcn/IssuingAuthorities/${id}`, body)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    }
};